import {
  InputTextProps,
  InputTextComponentInnerProps,
  InputTextStyledComponentProps,
  InputTextTypes,
} from "./types"
import React from "react"
import { TextInput } from "~/ui/primitives"
import { InputTextCore } from "./core"
import styled from '~/ui/styled'

const StyledTextInput = styled(TextInput)<InputTextStyledComponentProps>`
  padding: ${({ theme }) => theme.space.sm};
  border-radius: ${({ theme }) => theme.radii.sm};
  border-width: 1px;
  border-color: ${({ error, isFocus, theme }) => {
    if (error) {return theme.colors.danger}
    else if (isFocus) {return theme.colors.primary}
    else {return "#ccc"}
  }};
  border-style: solid;
  color: ${({ theme }) => theme.colors.text};
  background-color: ${({ theme }) => theme.colors.inputBackground};
`

export const InputTextInnerUnrefed: React.ForwardRefRenderFunction<
  TextInput,
  InputTextComponentInnerProps
> = ({ ...rest }, ref) => {
  return <StyledTextInput {...rest} ref={ref} />
}

export const InputTextInner = React.forwardRef(InputTextInnerUnrefed)

const InputText: React.ForwardRefRenderFunction<TextInput, InputTextProps> = (
  { label, validRule, ...rest },
  ref,
) => {
  return (
    <InputTextCore
      {...rest}
      label={label}
      validRule={validRule}
      type={InputTextTypes.INPUT_TEXT}
      ref={ref}
     />
  )
}

export default React.forwardRef(InputText)
